var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYouTubeLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.595 3.18193C16.991 2.93593 8.96401 2.93693 5.36501 3.18193C1.46801 3.44793 1.00901 5.80193 0.980011 11.9979C1.00901 18.1829 1.46401 20.5469 5.36501 20.8139C8.96501 21.0589 16.991 21.0599 20.595 20.8139C24.492 20.5479 24.951 18.1939 24.98 11.9979C24.951 5.81293 24.496 3.44893 20.595 3.18193ZM9.98001 15.9979V7.99793L17.98 11.9909L9.98001 15.9979Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.980011 -0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYouTubeLogoIcon);
export default __webpack_public_path__ + "static/media/youTube-logo-icon.7208c5969241e29d80a7f6955d2d9daf.svg";
export { ForwardRef as ReactComponent };